import Backbone from 'backbone';
import _ from 'lodash';
import $ from 'jquery';
import '../googletag';
import * as log from 'loglevel';
import { AdView } from '@smithsonian/js/ads/views/AdView';

export const AdsAppView = Backbone.View.extend({
    /*
     * Ads App View:
     * Manages which type of ads show be displayed (desktop or mobile)
     * and when they should be refreshed
     */

    video: false,
    activeAds: [],

    /*
     * when a number of user actions occur, the ads should refresh
     * this actionCount serves as placeholder for this.
     */
    actionCount: 0,

    settings: [
        {
            name: 'desktopMain',
            // id: 'div-gpt-ad-chuckweasley-1',
            sizes: [
                [728, 90],
                [970, 90],
                [970, 250],
                [1072, 325],
                [1, 1],
            ],
            pos: ['top'],
            collapseEmpty: false,
            refresh: false,
            platform: 'desktop',
            loading: 'instant', // options 'lazy' or 'instant'
        },
        {
            name: 'desktopOneByOne',
            sizes: [[1, 1]],
            pos: ['top'],
            collapseEmpty: false,
            refresh: false,
            platform: 'desktop',
            loading: 'instant',
        },
        {
            name: 'desktopSecondary',
            // id: 'div-gpt-ad-chuckweasley-secondary',
            sizes: [
                [728, 90],
                [970, 90],
                [970, 250],
            ],
            pos: ['middle'],
            collapseEmpty: false,
            refresh: false,
            platform: 'desktop',
            loading: 'instant', // options 'lazy' or 'instant'
        },
        {
            name: 'desktopSideTop',
            // id: 'div-gpt-ad-chuckweasley-2',
            sizes: [
                [300, 1050],
                [300, 600],
                [300, 250],
            ],
            pos: ['top'],
            collapseEmpty: false,
            refresh: true,
            platform: 'desktop',
            loading: 'lazy',
        },
        {
            name: 'desktopSideHouseTop',
            // id: 'div-gpt-ad-chuckweasley-house-top',
            sizes: [
                [300, 250],
                [300, 200],
            ],
            pos: ['house-top'],
            collapseEmpty: true,
            refresh: false,
            platform: 'desktop',
            loading: 'lazy',
        },
        {
            name: 'desktopSideHouseBottom',
            //id: 'div-gpt-ad-chuckweasley-house-bottom',
            sizes: [
                [300, 250],
                [300, 200],
            ],
            pos: ['house-bottom'],
            collapseEmpty: true,
            refresh: false,
            platform: 'desktop',
            loading: 'lazy',
        },
        {
            name: 'desktopSideBottom',
            sizes: [
                [300, 1050],
                [300, 600],
                [300, 250],
            ],
            pos: ['bottom'],
            collapseEmpty: false,
            refresh: true,
            platform: 'desktop',
            loading: 'lazy',
        },
        {
            name: 'desktopInArticle', // ad overrides should be named as desktopInArticle-0 (starting with 0 for the first position)
            sizes: [
                [728, 90],
                [300, 250],
                [447, 140],
            ],
            pos: ['inarticle'],
            collapseEmpty: false,
            refresh: true,
            platform: 'desktop',
            loading: 'lazy',
        },
        {
            name: 'desktopInArticle-0',
            sizes: [
                [300, 250],
                [740, 416],
                [728, 90],
            ],
            pos: ['inarticle-0'],
            collapseEmpty: false,
            refresh: false,
            platform: 'desktop',
            loading: 'lazy',
        },
        {
            name: 'mobileMain',
            // id: 'div-gpt-ad-chuckweasley-mobile-1',
            sizes: [
                [300, 250],
                [300, 50],
                [320, 50],
                [320, 100],
            ],
            pos: ['mobile-top'],
            collapseEmpty: false,
            refresh: true,
            platform: 'mobile',
            loading: 'instant',
        },
        {
            name: 'mobileMainSecondary',
            // id: 'div-gpt-ad-chuckweasley-mobile-secondary',
            sizes: [
                [300, 250],
                [300, 50],
                [320, 50],
                [320, 100],
            ],
            pos: ['mobile-middle'],
            collapseEmpty: false,
            refresh: false,
            platform: 'mobile',
            loading: 'instant', // options 'lazy' or 'instant'
        },
        {
            name: 'mobileBottom',
            // id: 'div-gpt-ad-chuckweasley-mobile-2',
            sizes: [
                [300, 250],
                [300, 50],
                [320, 50],
                [320, 100],
            ],
            pos: ['mobile-bottom'],
            collapseEmpty: false,
            refresh: true,
            platform: 'mobile',
            loading: 'instant',
        },
        {
            name: 'mobileInArticle', // ad overrides should be named as mobileInArticle-0 (starting with 0 for the first position)
            sizes: [[300, 250]],
            pos: ['mobile-inarticle'],
            collapseEmpty: false,
            refresh: true,
            platform: 'mobile',
            loading: 'lazy',
        },
        {
            name: 'mobileInArticle-0',
            sizes: [[300, 250]],
            pos: ['mobile-inarticle-0'],
            collapseEmpty: false,
            refresh: false,
            platform: 'mobile',
            loading: 'lazy',
        },
    ],

    initialize: function (options) {
        _.bindAll(
            this,
            'adsViewportRefresh',
            'adSetup',
            'adSlotSetup',
            'getSettings',
            'onDOMContentLoaded'
        );

        options = options ? options : {};

        this.video = options.video ? true : false;

        // list of ads to disable. (ads are all enabled by default)
        this.disableAd = options.disableAd ? options.disableAd : null;

        /*
         * Override default ad attributes
         * When instantiating AdsAppView, optional values for each ad can
         * be defined as in the following example:
         *
         *
         *   new AdsAppView({
         *       ads: [{
         *           name: 'desktopSideTop',
         *           attrs: {
         *               id: 'my-custom-id',
         *               sizes: [[300, 600], [300, 250]]
         *           }
         *       }, {
         *           name: 'mobileTop',
         *           attrs: {
         *               id: 'my-mobile-custom-id',
         *               sizes: [[300, 400], [300, 250]]
         *           }
         *       }]
         *   });
         *
         */

        _.each(
            options.ads,
            function (obj, key) {
                var settings = this.getSettings(obj.name);
                if (settings) {
                    _.extend(settings, obj.attrs);
                }
            },
            this
        );

        this.setup();

        if (options.mobileInArticleAds) {
            this.mobileInArticleAds = options.mobileInArticleAds;
        } else {
            this.mobileInArticleAds = [
                2, 4, 7, 10, 13, 16, 19, 22, 25, 28, 31, 34, 37, 40, 43, 46, 49,
            ];
        }
        if (options.desktopInArticleAds) {
            this.desktopInArticleAds = options.desktopInArticleAds;
        } else {
            this.desktopInArticleAds = [
                2, 6, 11, 15, 19, 24, 29, 34, 39, 44, 49,
            ];
        }

        // refresh ads on slideshow change
        $(document).on('slideshow:change', this.adsViewportRefresh);
        // refresh on essay change
        $(document).on('essay:change', this.adsViewportRefresh);

        // insert ad placeholders to the DOM
        document.addEventListener('DOMContentLoaded', this.onDOMContentLoaded);

        document.addEventListener(
            'photocontest:open-lightbox',
            function (evt) {
                if (
                    document.getElementById(
                        'div-gpt-ad-chuckweasley-photocontest-top'
                    )
                ) {
                    var photoContestSlot = this.getSlots().find(function (s) {
                        return (
                            s.getSlotId().getDomId() ===
                            'div-gpt-ad-chuckweasley-photocontest-top'
                        );
                    });
                    if (photoContestSlot) {
                        // refresh existing ad slot
                        log.info('photocontest-ad.refresh');
                        googletag.pubads().refresh([photoContestSlot]);
                    } else {
                        // setup new ad slot
                        log.info('photocontest-ad.setup');
                        this.adSlotSetup(
                            null,
                            $('#div-gpt-ad-chuckweasley-photocontest-top')
                        );
                    }
                }
            }.bind(this)
        );
    },

    setup: function () {
        /*
         * Setup and instantiate ads
         * We need to reference 'this' (AdsAppView instance)
         * to get the ad settings, but we can't override 'this' within
         * the googletag.
         */
        var that = this;

        googletag.cmd.push(function () {
            // video ads
            if (that.video) {
                googletag.companionAds().setRefreshUnfilledSlots(true);
            }
            // set targeting site
            googletag.pubads().setTargeting('Site', [window.GPT.SITE]);

            // lazy loading settings
            googletag.pubads().enableLazyLoad({
                // Fetch slots within 5 viewports.
                fetchMarginPercent: 200,
                // Render slots within 2 viewports.
                renderMarginPercent: 100,
                // Double the above values on mobile, where viewports are smaller
                // and users tend to scroll faster.
                mobileScaling: 2.0,
            });

            googletag
                .pubads()
                .addEventListener('impressionViewable', function (event) {
                    // refresh ad 20s after an impression has occurred
                    const $adSlot = $('#' + event.slot.getSlotElementId());
                    if ($adSlot) {
                        let addSettings = $adSlot.data('ad-settings');
                        const settings = that.getSettings(addSettings);
                        if (settings.refresh) {
                            setTimeout(function () {
                                console.log(
                                    'ad refresh:',
                                    addSettings,
                                    event.slot.getSlotElementId()
                                );
                                googletag.pubads().refresh([event.slot]);
                            }, 20000);
                        }
                    }
                })
                .addEventListener('slotOnload', function (event) {
                    var slot = event.slot;
                    var slotId = slot.getSlotId().getDomId();
                    var $adSlot;
                    var $sidebarAdSlot;
                    // initial position for ad slot
                    if (slotId.match('desktopInArticle-[0-9]{0,}-sidebar')) {
                        $adSlot = $(
                            '#' + slotId.replace('-sidebar', '')
                        ).parents('.ad-wrapper');
                        $sidebarAdSlot = $('#' + slotId);
                        $sidebarAdSlot
                            .parent()
                            .css('top', $adSlot.offset().top + 340);
                    }
                });

            googletag.enableServices();
        });
    },

    isMobile: function () {
        return window.innerWidth < 1068;
    },

    getSettings: function (settingsName) {
        return _.find(this.settings, function (item) {
            return settingsName === item.name;
        });
    },

    onDOMContentLoaded: function () {
        var $articleBody = $('[data-article-body]');
        var $articleBodyPg = $articleBody.children('p');
        var $articleSidebar = $('.article .articleRight');
        var adNamePrefix = this.isMobile()
            ? 'mobileInArticle-'
            : 'desktopInArticle-';
        var baseAdSettings = this.isMobile()
            ? 'mobileInArticle'
            : 'desktopInArticle';
        var articleAds = this.isMobile()
            ? this.mobileInArticleAds
            : this.desktopInArticleAds;

        if (!_.isArray(articleAds)) {
            articleAds = _.range(articleAds, $articleBodyPg.length, articleAds);
        }

        // in-article ads
        // these ads are dynamically inserted into the DOM
        // mobile vs desktop breakpoint @ 1068px
        if ($articleBody.length) {
            _.each(
                articleAds,
                function (adPosition, key) {
                    var adSettings = baseAdSettings;
                    var $adNode;
                    var $sidebarAdNode;
                    var adId = adNamePrefix + key;
                    log.info('in-article adSettings', adSettings, key);
                    if (this.getSettings(adId)) {
                        adSettings = adId;
                        log.info(
                            'in-article adSettings-X override',
                            adSettings
                        );
                    }
                    // loop should finish if there are there are no more paragraphs where to render ads
                    if (adPosition >= $articleBodyPg.length) {
                        return;
                    }
                    if (adPosition === 2 || this.isMobile()) {
                        // render just the ad, no full width
                        $adNode = $(
                            '<div id="' +
                                adId +
                                '" class="ad-slot" data-ad-settings="' +
                                adSettings +
                                '"></div>'
                        );
                    } else {
                        var containerWidth = document.body.offsetWidth;
                        // full width ad style
                        var adStyles = 'width:' + containerWidth + 'px';
                        $adNode = $(
                            '<div class="ad-wrapper"><div class="ad-container" style="' +
                                adStyles +
                                '"><div id="' +
                                adId +
                                '" class="ad-slot ad-article-slot" data-ad-settings="' +
                                adSettings +
                                '"></div></div></div>'
                        );
                        if (!this.isMobile()) {
                            // sidebar ad below full width ad
                            $sidebarAdNode = $(
                                '<div class="ad-sidebar-wrapper"><div id="' +
                                    adId +
                                    '-sidebar" class="ad-slot" data-ad-settings="desktopSideTop" data-article-ad="' +
                                    adId +
                                    '"></div>'
                            );
                            $articleSidebar.append($sidebarAdNode);
                        }
                    }

                    if (this.isMobile()) {
                        $adNode.addClass(
                            'article-slot-centered hidden-desktop'
                        );
                    }
                    if ($articleSidebar.length === 0) {
                        $('.article .article-columns').addClass(
                            'single-column'
                        );
                    }
                    $($articleBodyPg[adPosition]).before($adNode);

                    if ($sidebarAdNode) {
                        // align position for sidebar ad slots
                        var intervalId = setInterval(function () {
                            var offsetTop = $adNode.offset().top + 340;
                            console.log(
                                'reposition sidebar ad:',
                                key,
                                $adNode,
                                offsetTop
                            );
                            $sidebarAdNode.css('top', offsetTop);
                        }, 4000);
                        setTimeout(function () {
                            console.log('clearInterval', intervalId);
                            clearInterval(intervalId);
                        }, 40000);
                    }

                    // add padding at the bottom of the article when the ad is longer than the article
                    var $lastAd = $('.articleLeft .ad-wrapper');
                    if ($lastAd.length) {
                        var lastAdHeight =
                            $lastAd.offset().top + $lastAd.height() + 700;
                        var articleHeight =
                            $articleBody.offset().top + $articleBody.height();
                        if (lastAdHeight > articleHeight) {
                            $articleBody.css(
                                'padding-bottom',
                                lastAdHeight - articleHeight
                            );
                        }
                    }
                }.bind(this),
                this
            );
        }
        this.adSetup();
    },

    adSetup: function () {
        log.info('adSetup');
        // check for ad spots that need to be activated based on the scroll location
        // run every time the user scrolls
        // filters ads based on rules and determines if it should be setup or not
        var that = this;
        var $ads = $('.ad-slot');

        var $filteredAds = $ads.filter(
            function (key, node) {
                // filter ads to check if there's any ad that will be setup
                // filtered ads will be a list of the ads that will be setup
                //
                // get the node
                var $node = $(node);
                // info for slot setup
                var slotId = $node.attr('id');
                var adSettings = $node.data('ad-settings');

                // AD CONFIGURATION VALIDATION
                // check if slot is configured to use ad settings
                if (
                    !adSettings ||
                    (that.disableAd &&
                        that.disableAd.indexOf(adSettings) !== -1)
                ) {
                    return false;
                }

                // AD SETTINGS
                var settings = _.extend(
                    {
                        id: slotId,
                    },
                    that.getSettings(adSettings)
                );

                // AD PLATFORM
                if (settings.platform === 'mobile' && !this.isMobile()) {
                    // if platform mobile, but window width is desktop
                    // do nothing
                    log.warn('Ad mobile only, but desktop window:', slotId);
                    return false;
                } else if (settings.platform === 'desktop' && this.isMobile()) {
                    // if platform desktop, but window width is mobile
                    // do nothing
                    log.warn('Ad desktop only, but mobile window:', slotId);
                    return false;
                }

                return true;
            }.bind(this)
        );

        log.info('Ads.scrollSetup', $filteredAds.length);
        googletag.cmd.push(function () {
            $filteredAds.each(that.adSlotSetup);
        });
    },

    adSlotSetup: function (key, node) {
        // setups up a whole ad slot
        var $node = $(node);
        // info for slot setup
        var slotId = $node.attr('id');
        var adSettings = $node.data('ad-settings');

        // AD CONFIGURATION VALIDATION
        // check if slot is configured to use ad settings
        if (!adSettings) {
            return false;
        }

        // AD SETTINGS
        var settings = _.extend(
            {
                id: slotId,
            },
            this.getSettings(adSettings)
        );

        // AD INITIALIZATION
        // use id from the DOM node id
        // extend with settings defined in data-ad-settings
        // instantiate ad with these settings
        var ad = new AdView(settings);
        log.info('Ad successful setup: ', ad.id);
        // push ad to list of active ads
        this.activeAds.push(ad);

        // call googletag.display to display the ad slot
        googletag.display(ad.id);

        // refresh the slot and show the ad
        //log.info('ad slot refresh', ad.id);
        //googletag.pubads().refresh([ad.slot]);

        // Trigger an event stating that the ad was finished setting up.
        // This is used on TweenTribune to determine if there is an
        // interstitial to show.
        $(document).trigger('ads.setup-' + ad.id, ad);
    },

    getVisibilityState: function () {
        // get visibility state for all implementations (including prefixed browsers)
        return (
            document.visibilityState ||
            document.webkitVisibilityState ||
            document.mozVisibilityState ||
            document.msVisibilityState
        );
    },

    getSlots: function (ads) {
        // return the list of slots (for refreshing purposes)
        // from a list of ads
        var slots = [];
        // if an ads list is passed, use that
        // else use all ads in this.activeAds
        _.each(
            ads ? ads : this.activeAds,
            function (obj, key) {
                // if slot can be refreshed
                if (obj.refresh) {
                    slots.push(obj.slot);
                }
            },
            this
        );
        return slots;
    },

    inViewport: function (elem) {
        log.info('inViewport', elem);
        // check if an element is in the viewport
        var $elem = $(elem);
        var offset = $elem.offset();
        var pos = {
            offsetTop: offset ? offset.top : 0,
            height: $elem.height(),
        };
        var scrollY = $(window).scrollTop();
        // check if a little over 50% of the ad is within the viewport
        var isInViewport =
            pos.offsetTop >= scrollY - pos.height / 2.25 &&
            pos.offsetTop < scrollY + window.innerHeight - pos.height / 2.25;
        return isInViewport;
    },

    adsViewportRefresh: function () {
        var self = this;
        // Refresh all ads between:
        // start: window.scrollY
        // end: window.scrollY + window.innerHeight
        var ads = _.filter(this.activeAds, function (obj, key) {
            return self.inViewport(obj.el) && obj.refresh;
        });

        log.info('adsViewportRefresh', ads);

        // get the slot list from the ad list
        var slots = this.getSlots(ads);
        // trigger ads refresh
        if (googletag.pubads && slots.length) {
            googletag.pubads().refresh(slots);
        }
    },
});
